import { put } from 'redux-saga/effects';
import { initialize } from 'redux-form';

export default function* selectCreditCard(action) {
  yield put(initialize('ccForm', { ...action.payload, number: '' }));
}
